import { Pipe, PipeTransform } from '@angular/core';

import moment from 'moment';

@Pipe({
    name: 'age',
    standalone: true
})
export class AgePipe implements PipeTransform {

    transform(value: Date | moment.Moment): string {
        return value && moment().diff(value, 'years') + ' years';
    }

}
